import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Public content helpers
export const getContent = (collection, params = {}) =>
  api.get(`/content/${collection}`, { params }).then((r) => r.data);
export const getContentItem = (collection, id) =>
  api.get(`/content/${collection}/${id}`).then((r) => r.data);
export const getSiteContent = async (key) => {
  const data = await getContent("site_content", { key });
  return data[0]?.value || null;
};
export const submitEnquiry = (payload) => api.post(`/enquiries`, payload).then((r) => r.data);
export const uploadPrivate = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/uploads/private`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// Admin helpers
export const adminList = (collection) => api.get(`/admin/content/${collection}`).then((r) => r.data);
export const adminCreate = (collection, payload) => api.post(`/admin/content/${collection}`, payload).then((r) => r.data);
export const adminUpdate = (collection, id, payload) => api.put(`/admin/content/${collection}/${id}`, payload).then((r) => r.data);
export const adminDelete = (collection, id) => api.delete(`/admin/content/${collection}/${id}`).then((r) => r.data);
export const adminStats = () => api.get(`/admin/stats`).then((r) => r.data);
export const demoCount = () => api.get(`/admin/demo/count`).then((r) => r.data);
export const clearDemo = () => api.post(`/admin/demo/clear`).then((r) => r.data);
export const adminEnquiries = (params = {}) => api.get(`/admin/enquiries`, { params }).then((r) => r.data);
export const updateEnquiryStatus = (id, status) => api.put(`/admin/enquiries/${id}/status`, { status }).then((r) => r.data);
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post(`/admin/uploads`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export default api;
